import React, { useState } from 'react';
import fotos from '../fotos.json'; // Ajusta la ruta a tu JSON
import '../css/FotosReto.css'; // Importamos tus nuevos estilos
import letrasDisney from "../images/pngegg.png";

const FotosReto = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFullScreen, setIsFullScreen] = useState(false);

  // Asegurar que siempre tengamos fotos cargadas
  if (!fotos || fotos.length === 0) return null;

  const total = fotos.length;

  // Índices circulares para izquierda y derecha
  const leftIndex = (currentIndex - 1 + total) % total;
  const rightIndex = (currentIndex + 1) % total;

  const goNext = () => {
    setCurrentIndex((prev) => (prev + 1) % total);
  };

  const goPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + total) % total);
  };

  const handleCenterClick = () => {
    setIsFullScreen(true);
  };

  return (
    <div className="fotos-reto-container">
      <div className="disney-header-container">
        <img src={letrasDisney} alt="Disneyland Paris" className="disney-logo-img" />
        <span className="disney-subtitle-location">→ Higueruela</span>
      </div>

      <h2 className="fotos-reto-title">Así se vivió el Reto!!</h2>
      
      <div className="fotos-reto-carousel">
        {/* Foto Izquierda */}
        <div className="fotos-reto-side-wrapper left" onClick={goPrev}>
          <img 
            src={fotos[leftIndex].url} 
            alt={fotos[leftIndex].nombre} 
            className="fotos-reto-image" 
          />
          <div className="fotos-reto-overlay" />
        </div>

        {/* Foto Central */}
        <div className="fotos-reto-center-wrapper" onClick={handleCenterClick}>
          <img 
            src={fotos[currentIndex].url} 
            alt={fotos[currentIndex].nombre} 
            className="fotos-reto-center-image" 
          />
          <div className="fotos-reto-badge">Toca para ampliar</div>
        </div>

        {/* Foto Derecha */}
        <div className="fotos-reto-side-wrapper right" onClick={goNext}>
          <img 
            src={fotos[rightIndex].url} 
            alt={fotos[rightIndex].nombre} 
            className="fotos-reto-image" 
          />
          <div className="fotos-reto-overlay" />
        </div>
      </div>

      {/* --- MODO PANTALLA COMPLETA (LIGHTBOX CON NAVEGACIÓN TÁCTIL) --- */}
      {isFullScreen && (
        <div className="fotos-reto-lightbox" onClick={() => setIsFullScreen(false)}>
          {/* Botón Cerrar */}
          <button className="fotos-reto-close-btn" onClick={() => setIsFullScreen(false)}>×</button>

          <div className="lightbox-content-wrapper" onClick={(e) => e.stopPropagation()}>
            {/* Zona Izquierda: Retroceder */}
            <div className="lightbox-nav-zone left" onClick={goPrev}>
              <span className="lightbox-arrow">◀</span>
            </div>

            {/* Imagen Ampliada */}
            <img 
              src={fotos[currentIndex].url} 
              alt={fotos[currentIndex].nombre} 
              className="fotos-reto-lightbox-img" 
            />

            {/* Zona Derecha: Avanzar */}
            <div className="lightbox-nav-zone right" onClick={goNext}>
              <span className="lightbox-arrow">▶</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FotosReto;